import { render } from "./FirstFunc.vue?vue&type=template&id=2137a7ea"
import script from "./FirstFunc.vue?vue&type=script&lang=js"
export * from "./FirstFunc.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__